import { NotFoundRouteProps } from "@tanstack/react-router"
import { ElementType } from "react"
import { useTranslation } from "react-i18next"

import { useTheme } from "@/utilities/hooks/useTheme"

import { LinkButton } from "../atoms/Button"
import Card from "../atoms/Card"
import Heading from "../atoms/Heading"
import Text from "../atoms/Text"

import Footer from "./navigation/Footer"
import TopNavigationBar from "./navigation/TopNavigationBar"

export const NOT_FOUND_SESSION = "session"

function RootNotFound(props: NotFoundRouteProps) {
  const { documentThemeMode, scannedArea } = useTheme()
  const whiteLabel =
    documentThemeMode === "whiteLabel" ? scannedArea : undefined
  const { t } = useTranslation()

  const isSessionNotFound = (props.data as any)?.type === NOT_FOUND_SESSION
  const ElementTag = (isSessionNotFound ? "main" : "div") as ElementType

  return (
    <>
      {isSessionNotFound && <TopNavigationBar />}
      <ElementTag className="error-boundary">
        <Card>
          <Heading className="center">
            {isSessionNotFound
              ? t("errors.notFound.isSessionNotFound.header")
              : "404"}
          </Heading>
          {isSessionNotFound ? (
            <Text className="center">
              {t("errors.notFound.isSessionNotFound.body")}
            </Text>
          ) : (
            <Text className="center">{t("errors.common.notFound")}</Text>
          )}

          <LinkButton
            hue="secondary"
            variant="default"
            to={whiteLabel ? "/qr/$qrLookupID/welcome" : "/"}
            params={whiteLabel}
            preload={false}
          >
            {t("common.goHome")}
          </LinkButton>
          <Text className="center">
            {t("common.getHelp")}{" "}
            <LinkButton
              hue="primary"
              presentation="link"
              to={whiteLabel ? "/qr/$qrLookupID/help" : "/help"}
              style={{ textDecoration: "underline" }}
              params={whiteLabel}
            >
              {t("common.clickHere")}
            </LinkButton>
          </Text>
        </Card>
      </ElementTag>
      {isSessionNotFound && <Footer />}
    </>
  )
}

export default RootNotFound
